// Shared hydration signal so the API interceptor can wait for the initial
// auth hydration before doing its own token refresh — prevents double-rotation
// of the refresh token that would log the user out on page reload.

let _resolve: (() => void) | null = null;

export const hydrationSignal = {
  promise: new Promise<void>((res) => { _resolve = res; }),
  resolve() {
    _resolve?.();
  },
};
